import settings from "./settings";
import Cookies from "js-cookie";

import dic from "./dic";
import Common from "./Common";

/**
 * PrizeManager
 * 賞品の管理
 */
export default class PrizeManager {

    constructor(minApplyPrice = settings.minApplyPrice) {
        this.minApplyPrice = minApplyPrice;

        this.EVENT = {
            GENERATE_CALC_BUTTON: "generate_calc_button"
        }
    }

    /**
     * 初期状態で全ての賞品選択を無効に
     */
    static disableAllPrize() {
        let $prize = $(settings.selector.prizeBlock).find("[type=radio]");

        $prize.off().on("click", (e) => {
            e.preventDefault();
            alert(dic.msgPriceLowerAlert);
            $prize.prop("checked", false);
        });
    }

    /**
     * 選択状態を有効にする
     */
    static enableAllPrize() {
        let $prize = $(settings.selector.prizeBlock).find("[type=radio]");
        $prize.off();
        $prize.prop("disabled", false);
    }

    /**
     * 賞品選択が有効な金額かチェック
     * 有効なら賞品選択を有効にする
     * 無効なら選択済みの賞品をクリアする
     * @param totalPrice
     */
    checkEnablePrize(totalPrice) {
        if (!isNaN(totalPrice)) {

            // ボタンと入力欄表示切り替え
            $(settings.selector.totalPrice).find(".calc").css({"display": "none"});
            $(settings.selector.totalPrice).find("#total-price input").val(totalPrice.toLocaleString().replace(/\.00$/, ""));
            $(settings.selector.totalPrice).find("#total-price").css({"display": "inline"});


            if (totalPrice >= settings.minApplyPrice) {
                PrizeManager.enableAllPrize();
            }else{
                PrizeManager.disableAllPrize();
                PrizeManager.clearPrizeSelectable();
            }
        }
    }

    /**
     * 計算ボタンを再度表示
     */
    static resetCalcButton() {

        // $(settings.selector.totalPrice).find("#result").html(`<button type="button" class="calc"><img src="btn_calculation.gif" alt="計算する"></button>`);
        $(settings.selector.totalPrice).find(".calc").css({"display": "block"});
        $(settings.selector.totalPrice).find("#total-price").css({"display": "none"});


        // 計算ボタン生成EVENT発火
        $(settings.selector.totalPrice).find("button.calc").trigger("generate_calc_button");
    }

    /**
     * 賞品選択のクリア
     */
    static clearPrizeSelectable() {
        $(settings.selector.prizeBlock).find("[type=radio]").prop("checked", false);
    }

    /**
     * Cookiesから賞品情報を復元
     * @param totalPrice
     * @returns {boolean}
     */
    restorePrizeFromCookies(totalPrice) {
        let $prize = $(settings.selector.prizeBlock);
        let data = Cookies.getJSON(settings.appName);

        // 先にクリア処理・無効化処理を行う
        PrizeManager.clearPrizeSelectable();
        PrizeManager.disableAllPrize();

        if (!data || !data.prize) return false;

        // 入力済み金額に応じてフォーム有効化処理
        this.checkEnablePrize(totalPrice);

        // 入力金額が下限を超えている場合のみチェック復元
        // （金額未満のときにチェックが復元されるのを防ぐ）
        if (totalPrice >= settings.minApplyPrice) {
            $prize.find("[type=radio]").each((index, elem) => {
                Common.insertFormValues($(elem), data.prize);
            });
        }

        return true;
    }

    /**
     * 賞品の選択状況を取得
     * @returns {boolean}
     */
    static get isPrizeSelected() {
        let result = false;

        $(settings.selector.prizeBlock).find("[type=radio]").each((index, elem) => {
            let $elem = $(elem);

            if ($elem.prop("checked")) {
                result = true;
                return false;
            }
        });

        return result;
    }


    /**
     * 計算結果が表示されているかどうか
     * @returns {boolean}
     */
    static get isShowCalcResult() {
        let $calcBlock = $(settings.selector.totalPrice);
        let result = $calcBlock.find("button").css("display") !== "none";
        return result;
    }
}
